import { ChangeEvent, useEffect, useState } from 'react';
import { TextInput } from '../../Calculators/calculator-revamp/components/form-components/InputBox';
import { DateInput } from '../../Calculators/calculator-revamp/components/form-components/InputDate';
import { AtcAdvanceTaxPaid } from '../Atc-calculator-constants';
import { CALCULATOR_TAB_PROPS, TaxPaidAmount } from '../types';
import { removeCommas } from '../../Utils/CommonUtils';

const AtcAdvanceTax = ({
  hasError,
  setGlobalError,
  setInputData,
  inputTabData,
}: CALCULATOR_TAB_PROPS) => {
  const [inputRows, setInputRows] = useState({
    AdvanceTaxPaid: inputTabData?.AdvanceTaxPaid || [
      { id: 1, Date: '04/01/2024', Amount: '' },
    ],
  });
  const [lastId, setlastId] = useState(() => {
    const taxPaid = Array.isArray(inputTabData?.AdvanceTaxPaid)
      ? inputTabData.AdvanceTaxPaid
      : [];
    return taxPaid.length ? taxPaid[taxPaid.length - 1]?.id : 1;
  });

  const handleAddRow = () => {
    setInputRows((prevState) => {
      const taxPaidArray = Array.isArray(prevState?.AdvanceTaxPaid)
        ? (prevState.AdvanceTaxPaid as TaxPaidAmount[])
        : [];
      return {
        AdvanceTaxPaid: [
          ...taxPaidArray,
          { id: (lastId || 0) + 1, Date: '04/01/2024', Amount: '' },
        ],
      };
    });
    setlastId((prevId) => (prevId || 0) + 1);
  };

  const handleRemoveRow = (id: number) => {
    setInputRows((prevState) => {
      const taxPaidArray = Array.isArray(prevState.AdvanceTaxPaid)
        ? (prevState.AdvanceTaxPaid as TaxPaidAmount[])
        : [];
      return {
        AdvanceTaxPaid: taxPaidArray.filter((row) => row.id !== id),
      };
    });
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>, id: number) => {
    const key = e.target.id;
    const value = removeCommas(e.target.value);
    setInputRows((prevState) => {
      const taxPaidArray = Array.isArray(prevState.AdvanceTaxPaid)
        ? (prevState.AdvanceTaxPaid as TaxPaidAmount[])
        : [];
      const updatedRows = taxPaidArray.map((row) =>
        row.id === id ? { ...row, [key]: value } : row
      );
      return { ...prevState, AdvanceTaxPaid: updatedRows };
    });
  };

  const valueInput = true;
  function formatDateForAdvanceTax(dateStr: string, valueInput?: boolean) {
    const date = new Date(dateStr);
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return valueInput ? `${year}-${month}-${day}` : `${month}/${day}/${year}`;
  }

  const handleDateChange = (e: ChangeEvent<HTMLInputElement>, id: number) => {
    const value = e.target.value;
    const key = e.target.id;
    const datevalue = formatDateForAdvanceTax(value);
    setInputRows((prevState) => {
      const taxPaidArray = Array.isArray(prevState.AdvanceTaxPaid)
        ? (prevState.AdvanceTaxPaid as TaxPaidAmount[])
        : [];
      const updatedRows = taxPaidArray.map((row) =>
        row.id === id ? { ...row, [key]: datevalue } : row
      );
      return { ...prevState, AdvanceTaxPaid: updatedRows };
    });
  };

  useEffect(() => {
    setInputData?.((prevState) => ({
      ...prevState,
      AdvanceTaxPaid: inputRows.AdvanceTaxPaid,
    }));
  }, [inputRows]);

  return (
    <>
      <div className="font-bold text-base mb-3 sm:mb-6 sm:mt-2">
        Advance Tax Paid
      </div>
      {Array.isArray(inputRows.AdvanceTaxPaid) &&
        inputRows.AdvanceTaxPaid.map((row) => (
          <div
            key={row.id}
            className="flex gap-12 sm:mb-6 sm:flex-col sm:gap-0 sm:items-end justify-center"
          >
            <div
              className={`flex w-full sm:w-full gap-12 sm:block py-3 sm:py-0`}
            >
              {AtcAdvanceTaxPaid.map((props, index) => {
                if (props.type == 'text') {
                  return (
                    <div className="w-full font-medium" key={index}>
                      <TextInput
                        key={index}
                        {...props}
                        value={
                          Array.isArray(inputTabData?.AdvanceTaxPaid)
                            ? (
                                inputTabData.AdvanceTaxPaid as TaxPaidAmount[]
                              ).find((dataRow) => dataRow.id === row.id)
                                ?.Amount || ''
                            : ''
                        }
                        hasError={hasError}
                        setGlobalError={setGlobalError}
                        onTextChangeFn={(e) => handleChange(e, row.id)}
                      />
                    </div>
                  );
                } else {
                  return (
                    <div className="w-full font-medium" key={index}>
                      <DateInput
                        {...props}
                        value={
                          Array.isArray(inputTabData?.AdvanceTaxPaid)
                            ? formatDateForAdvanceTax(
                                (
                                  inputTabData.AdvanceTaxPaid as TaxPaidAmount[]
                                ).find((dataRow) => dataRow.id === row.id)
                                  ?.Date || '',
                                valueInput
                              )
                            : '2024-04-01'
                        }
                        onDateChangeFn={(e) => handleDateChange(e, row.id)}
                      />
                    </div>
                  );
                }
              })}
            </div>
            {row.id === lastId ? (
              <div className="flex items-center">
                <a
                  className="cursor-pointer text-blue-350"
                  onClick={handleAddRow}
                >
                  <img
                    className="h-8 w-8"
                    src="https://assets.clear.in/cleartax/images/1728584454_pluscircle.svg"
                    alt=""
                  />
                </a>
              </div>
            ) : (
              <div className="flex items-center w-[3.5%] justify-center sm:w-[9%]">
                <a
                  className="text-s-32 font-semibold flex items-center cursor-pointer"
                  onClick={() => handleRemoveRow(row.id)}
                >
                  <img
                    className="h-8 w-9"
                    src="https://assets.clear.in/cleartax/images/1729620942_minuscircle.svg"
                    alt=""
                  />
                </a>
              </div>
            )}
          </div>
        ))}
    </>
  );
};

export default AtcAdvanceTax;
